import { interpret } from "./interpret.js";
import { averageDistributions } from "./math.js";

export class AnalysisUnavailableError extends Error {
  constructor() {
    super("Nessun motore di analisi disponibile");
    this.name = "AnalysisUnavailableError";
  }
}

export const ENGINES = Object.freeze({ advanced: "advanced", quick: "quick" });

export class HybridAnalyzer {
  constructor(local, remote, reporter = { report() {} }) {
    this.local = local;
    this.remote = remote;
    this.reporter = reporter;
  }

  get ready() {
    return this.local.ready || this.remote.available;
  }

  async analyze({ distributions = [], snapshots = [], source = "photo" }) {
    const localResult = distributions.length && this.local.ready ? this.local.describe(averageDistributions(distributions)) : null;
    if (this.remote.available && snapshots.length) {
      try {
        const data = await this.remote.predict(snapshots, source);
        const metadata = { classes: data.classes, uncertainty: data.uncertainty || this.local.metadata?.uncertainty };
        const ordered = data.classes.map((spec) => data.probabilities[spec.id] ?? 0);
        return { result: interpret(ordered, metadata), engine: ENGINES.advanced, modelVersion: data.model_version };
      } catch (error) {
        if (error?.status >= 500 && error.status !== 503) this.reporter.report(error, "advanced-analysis");
      }
    }
    if (localResult) return { result: localResult, engine: ENGINES.quick, modelVersion: this.local.metadata?.model_version };
    throw new AnalysisUnavailableError();
  }
}
